import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, ProtectedRoute } from "@/auth/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PublicMap from "@/pages/PublicMap";
import Academy from "@/pages/Academy";
import PermitFinder from "@/pages/PermitFinder";
import Marketing from "@/pages/Marketing";
import DashboardLayout from "@/pages/dashboard/Layout";
import Dashboard from "@/pages/dashboard/Dashboard";
import Profile from "@/pages/dashboard/Profile";
import MenuPage from "@/pages/dashboard/Menu";
import Awards from "@/pages/dashboard/Awards";
import Events from "@/pages/dashboard/Events";
import Location from "@/pages/dashboard/Location";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/map" element={<PublicMap />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/permit-finder" element={<PermitFinder />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="menu" element={<MenuPage />} />
            <Route path="awards" element={<Awards />} />
            <Route path="events" element={<Events />} />
            <Route path="location" element={<Location />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
